import { config } from '../config';
import { STORAGE_KEYS } from './storage.util';

/**
 * Builds the AI webinar try-ai-flow URL with optional state param (for token-from-state on the receiving app).
 * Used by AILogin and SignupVerifyEmail for consistent redirect after login/signup.
 */
export function getAilaunchRedirectUrl(): string {
  const baseUrl =
    config.easywebinar_v2_url && config.easywebinar_v2_url !== 'N/A'
      ? config.easywebinar_v2_url
      : window.location.origin;
  const state =
    typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEYS.STATE) : null;
  const path = `${baseUrl.replace(/\/$/, '')}/ai-webinar/try-ai-flow`;
  return `${path}${state ? `?state=${state}` : ''}`;
}
